import React, { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Drawer,
  Form,
  Icon,
  Tooltip,
  Input,
  notification,
  Row,
  Select,
  Table
} from 'antd'

import {
  Countries,
  DesignationList,
  issueTypeList,
  formItemLayout
} from '../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../components/_utils/appFormUtils'
import { updateAbstractFxn } from './actions/index'
import ReactHtmlParser from 'react-html-parser'
const { Option } = Select;


const EditAbstractSubmission = props => {
  const {
    form: { getFieldDecorator, setFieldsValue },
    visible,
    onClose,
    article,
    reload
  } = props

  const dispatch = useDispatch()

  const initialAuthorState = {
    author: {},
    coAuthors: []
  }

  const [authorData, setAuthorData] = useState(initialAuthorState)
  const [abstractFile, setAbstractFile] = useState(null);
  const [copyrightForm, setCopyrightForm] = useState(null);
  const [supportingFile, setSupportingFile] = useState(null);
  const [journalListArr, setJournalListArr] = useState([]);

  const updateAuthor = data => {
    setAuthorData(prev => ({
      ...prev,
      author: {
        ...prev.author,
        ...data
      }
    }))
  }

  const updateCoAuthor = (data, index) => {
    let clone = [...authorData.coAuthors]

    if (clone[index]) {
      clone[index] = {
        ...clone[index],
        ...data
      }
    }

    setAuthorData(prev => ({
      ...prev,
      coAuthors: clone
    }))
  }

  const setFormData = () => {
    if (!article) return

    setFieldsValue({
      titleOfAbstract: article.titleOfAbstract,
      country: article.country,
      issueType: article.issueType,
      researchArea: article.researchArea,
      speakerNote: article.speakerNote,
      abstract: article.abstract,
      keywords: article.keywords ? article.keywords.join(', ') : '',
      journal: article.journal ? (article.journal._id || article.journal) : '',
    })
    let coAuthors = []

    const author = {
      name: article.authorName || '',
      email: article.email || '',
      mobile: article.mobile || '',
      instituteAffiliated: article.institution || '',
      designation: article.designation || '',
      country: article.country || '',
      orcidId: article.orcidId || ''
    }

    coAuthors = article.coAuthors.map(co => ({
      name: co.name || '',
      email: co.email || '',
      instituteAffiliated: co.affiliation || co.instituteAffiliated || '',
      country: co.country || '',
      orcidId: co.orcidId || ''
    }))
    setAuthorData({
      author,
      coAuthors
    })
  }
  useEffect(() => {
    if (visible && article && article._id) {
      setTimeout(() => {
        setFormData()
      }, 0)
    }
  }, [visible, article && article._id])

  const handleSubmit = e => {
    e.preventDefault()

    const { form } = props

    form.validateFieldsAndScroll(async (err, values) => {
      console.log("Form Values to be sent:", values);
      if (err) {
        notification.error({
          message: 'Required',
          description: 'Fill all required fields.'
        })
        return
      }

      values.abstractId = article._id
      values.author = authorData.author
      values.coAuthors = authorData.coAuthors
      values.flag = 'onlineAbstract';

      if (values.keywords) {
        values.keywords = values.keywords
          .split(',')
          .map(x => x.trim())
          .filter(Boolean)
      }
      let fd = new FormData()
      fd.append('obj', JSON.stringify(values))
      if (abstractFile) fd.append('abstractFile', abstractFile)
      if (copyrightForm) fd.append('copyrightForm', copyrightForm)
      if (supportingFile) fd.append('supportingFile', supportingFile)


      // let { success, message } = await dispatch(updateAbstractFxn(values))
      console.log("Values object being sent to API:", values);
      let { success, message,data } = await dispatch(updateAbstractFxn(fd))
      if (success) {
        console.log("SERVER PERSISTED DATA:", data);
        notification.success({
          message: message || 'Updated successfully'
        })

        reload && reload()
        onClose && onClose()
      } else {
        notification.error({
          message: message || 'Update failed'
        })
      }
    })
  }
  useEffect(() => {
    const loadJournalList = async () => {
      // Import JournalList action if not already imported
      const { JournalList } = require('../journals/actions');
      let { data } = await JournalList();
      setJournalListArr(data || []);
    };
    loadJournalList();
  }, []);
  const chooseDocument = e => {
    const { name, files } = e.target;
    if (files && files.length) {
      if (name === "abstractFile") setAbstractFile(files[0]);
      if (name === "copyrightForm") setCopyrightForm(files[0]);
      if (name === "supportingFile") setSupportingFile(files[0]);
    }
  };

  return (
    <Drawer
      title="Edit Abstract Submission"
      width="86%"
      placement="right"
      visible={visible}
      onClose={onClose}
      destroyOnClose
    >
      <Card>
        <Form onSubmit={handleSubmit} className="inputForm">
          <Row gutter={16}>

            {/* BASIC FIELDS */}
            {/*<Col span={24}>*/}
            {/*  <GetEachFormFields*/}
            {/*    getFieldDecorator={getFieldDecorator}*/}
            {/*    item={{*/}
            {/*      label: 'Abstract Title',*/}
            {/*      key: 'titleOfAbstract',*/}
            {/*      type: 'text',*/}
            {/*      required: true*/}
            {/*    }}*/}
            {/*    formItemLayout={formItemLayout}*/}
            {/*  />*/}
            {/*</Col>*/}
            {/*/!*  <GetEachFormFields*!/*/}
            {/*/!*    getFieldDecorator={getFieldDecorator}*!/*/}
            {/*/!*    item={{ label: 'Issue Type', key: 'issueType', type: 'text' }}*!/*/}
            {/*/!*    formItemLayout={formItemLayout}*!/*/}
            {/*/!*  />*!/*/}
            {/*/!*</Col>*!/*/}
            {/*<Col span={12}>*/}
            {/*  <Form.Item label="Issue Type">*/}
            {/*    {getFieldDecorator('issueType', {*/}
            {/*      initialValue: article.issueType,*/}
            {/*    })(*/}
            {/*      <Select*/}
            {/*        placeholder="Select Issue Type"*/}
            {/*        onChange={(val) => setFieldsValue({ issueType: val })}*/}
            {/*      >*/}
            {/*        <Select.Option value="Regular Issue">Regular Issue</Select.Option>*/}
            {/*        <Select.Option value="Special Issue">Special Issue</Select.Option>*/}
            {/*      </Select>*/}
            {/*    )}*/}
            {/*  </Form.Item>*/}
            {/*</Col>*/}

            {/*<Col span={12}>*/}
            {/*  <GetEachFormFields*/}
            {/*    getFieldDecorator={getFieldDecorator}*/}
            {/*    item={{ label: 'Research Area', key: 'researchArea', type: 'text' }}*/}
            {/*    formItemLayout={formItemLayout}*/}
            {/*  />*/}
            {/*</Col>*/}

            {/*<Col span={24}>*/}
            {/*  <GetEachFormFields*/}
            {/*    getFieldDecorator={getFieldDecorator}*/}
            {/*    item={{*/}
            {/*      label: 'Speaker Note',*/}
            {/*      key: 'speakerNote',*/}
            {/*      type: 'textArea'*/}
            {/*    }}*/}
            {/*    formItemLayout={formItemLayout}*/}
            {/*  />*/}
            {/*</Col>*/}
            {/* 1. Abstract Information */}
            <Card
              title={<span><Icon type="file-text" /> 1. Abstract Information</span>}
              style={{ marginBottom: '24px' }} // Adds the vertical space
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Journal / Event">
                    {getFieldDecorator('journal', {
                      initialValue: article.journal ? (article.journal._id || article.journal) : undefined,
                      rules: [{ required: true, message: 'Please select a journal!' }],
                    })(
                      <Select
                        placeholder="Select Journal"
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {journalListArr.map(j => (
                          <Option key={j._id} value={j._id}>{j.name}</Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                {/* Issue Type */}
                <Col span={12}>
                  <Form.Item label="Issue Type or Conference Track">
                    {getFieldDecorator('issueType', {
                      initialValue: article.issueType,
                      rules: [{ required: true, message: 'Please select issue type' }],
                    })(
                      <Select
                        placeholder="Select Issue Type"
                        onChange={(val) => setFieldsValue({ issueType: val })}
                      >
                        {issueTypeList && issueTypeList.map(issue => (
                          <Option key={issue} value={issue}>
                            {issue}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>

                {/* Title of Abstract */}
                <Col span={24}>
                  <GetEachFormFields
                    getFieldDecorator={getFieldDecorator}
                    item={{
                      label: 'Title of Abstract',
                      key: 'titleOfAbstract',
                      type: 'text',
                      required: true,
                      placeholder: 'Enter the title of your abstract'
                    }}
                    formItemLayout={formItemLayout}
                  />
                </Col>

                {/* Research Area */}
                <Col span={12}>
                  <GetEachFormFields
                    getFieldDecorator={getFieldDecorator}
                    item={{
                      label: 'Research Area',
                      key: 'researchArea',
                      type: 'text',
                      required: true,
                      placeholder: 'Select Research Area'
                    }}
                    formItemLayout={formItemLayout}
                  />
                </Col>

                {/* Keywords */}
                <Col span={12}>
                  <GetEachFormFields
                    getFieldDecorator={getFieldDecorator}
                    item={{
                      label: 'Keywords (up to 6)',
                      key: 'keywords',
                      type: 'text',
                      required: true,
                      placeholder: 'Add keywords separated by commas'
                    }}
                    formItemLayout={formItemLayout}
                  />
                </Col>

              </Row>
            </Card>
            {/* AUTHOR SECTION */}
            {/*<Col span={24}>*/}
            {/*  <Card title="Author" style={{ marginBottom: '24px' }}>*/}

            {/*    <Row gutter={16}>*/}
            {/*      <Col span={6}>*/}
            {/*        <Form.Item label="Name">*/}
            {/*          <Input*/}
            {/*            value={authorData.author.name}*/}
            {/*            onChange={e =>*/}
            {/*              updateAuthor({ name: e.target.value })*/}
            {/*            }*/}
            {/*          />*/}
            {/*        </Form.Item>*/}
            {/*      </Col>*/}

            {/*      <Col span={6}>*/}
            {/*        <Form.Item label="Email">*/}
            {/*          <Input*/}
            {/*            value={authorData.author.email}*/}
            {/*            onChange={e =>*/}
            {/*              updateAuthor({ email: e.target.value })*/}
            {/*            }*/}
            {/*          />*/}
            {/*        </Form.Item>*/}
            {/*      </Col>*/}

            {/*      <Col span={6}>*/}
            {/*        <Form.Item label="Institute">*/}
            {/*          <Input*/}
            {/*            value={authorData.author.instituteAffiliated}*/}
            {/*            onChange={e =>*/}
            {/*              updateAuthor({*/}
            {/*                instituteAffiliated: e.target.value*/}
            {/*              })*/}
            {/*            }*/}
            {/*          />*/}
            {/*        </Form.Item>*/}
            {/*      </Col>*/}

            {/*      <Col span={6}>*/}
            {/*        <Form.Item label="Designation">*/}
            {/*          <Input*/}
            {/*            value={authorData.author.designation}*/}
            {/*            onChange={e =>*/}
            {/*              updateAuthor({ designation: e.target.value })*/}
            {/*            }*/}
            {/*          />*/}
            {/*        </Form.Item>*/}
            {/*      </Col>*/}
            {/*    </Row>*/}

            {/*  </Card>*/}
            {/*</Col>*/}

            {/* 2. Corresponding Author Details */}
            <Card
              title={<span><Icon type="user" /> 2. Corresponding Author Details</span>}
              style={{ marginBottom: '24px' }}
            >
              <Row gutter={16}>

                {/* ROW 1 */}
                <Col span={8}>
                  <Form.Item label="Corr. Author Name">
                    <Input
                      placeholder="Full name of the corresponding author"
                      value={authorData.author.name}
                      onChange={e => updateAuthor({ name: e.target.value })}
                    />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item label="Email">
                    <Input
                      placeholder="name@email.com"
                      value={authorData.author.email}
                      onChange={e => updateAuthor({ email: e.target.value })}
                    />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item label="Mobile Number">
                    <Input
                      placeholder="enter mobile no."
                      value={authorData.author.mobile}
                      onChange={e => updateAuthor({ mobile: e.target.value })}
                    />
                  </Form.Item>
                </Col>

                {/* ROW 2 */}
                <Col span={8}>
                  <Form.Item label="Affiliation / Institution">
                    <Input
                      placeholder="Enter your institution"
                      value={authorData.author.instituteAffiliated}
                      onChange={e => updateAuthor({ instituteAffiliated: e.target.value })}
                    />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item label="Designation">
                    <Select
                      placeholder="Choose Designation"
                      value={authorData.author.designation}
                      onChange={val => updateAuthor({ designation: val })}
                    >
                      {DesignationList && DesignationList.map(value => (
                        <Option key={value} value={value}>
                          {value}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item label="Country">
                    <Select
                      showSearch
                      placeholder="Select Country"
                      value={authorData.author.country}
                      onChange={val => updateAuthor({ country: val })}
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {Countries && Countries.map(country => (
                        <Option key={country.id || country.name} value={country.name}>
                          {country.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* ROW 3 */}
                <Col span={8}>
                  <Form.Item label="ORCID ID (Optional)">
                    <Input
                      placeholder="0000-0000-0000-0000"
                      value={authorData.author.orcidId}
                      onChange={e => updateAuthor({ orcidId: e.target.value })}
                    />
                  </Form.Item>
                </Col>

              </Row>
            </Card>

            {/* CO AUTHORS */}
            {/*{authorData.coAuthors.length > 0 && (*/}
            {/*  <Col span={24}>*/}
            {/*    <Card title="Co Authors">*/}

            {/*      {authorData.coAuthors.map((item, index) => (*/}
            {/*        <Row gutter={16} key={index} style={{ marginBottom: 10 }}>*/}

            {/*          <Col span={6}>*/}
            {/*            <Form.Item label="Name">*/}
            {/*              <Input*/}
            {/*                value={item.name}*/}
            {/*                onChange={e =>*/}
            {/*                  updateCoAuthor({ name: e.target.value }, index)*/}
            {/*                }*/}
            {/*              />*/}
            {/*            </Form.Item>*/}
            {/*          </Col>*/}

            {/*          <Col span={6}>*/}
            {/*            <Form.Item label="Email">*/}
            {/*              <Input*/}
            {/*                value={item.email}*/}
            {/*                onChange={e =>*/}
            {/*                  updateCoAuthor({ email: e.target.value }, index)*/}
            {/*                }*/}
            {/*              />*/}
            {/*            </Form.Item>*/}
            {/*          </Col>*/}

            {/*          <Col span={6}>*/}
            {/*            <Form.Item label="Institute Affiliated">*/}
            {/*              <Input*/}
            {/*                value={item.instituteAffiliated}*/}
            {/*                onChange={e =>*/}
            {/*                  updateCoAuthor(*/}
            {/*                    { instituteAffiliated: e.target.value },*/}
            {/*                    index*/}
            {/*                  )*/}
            {/*                }*/}
            {/*              />*/}
            {/*            </Form.Item>*/}
            {/*          </Col>*/}

            {/*          <Col span={6}>*/}
            {/*            <Form.Item label="Designation">*/}
            {/*              <Input*/}
            {/*                value={item.designation}*/}
            {/*                onChange={e =>*/}
            {/*                  updateCoAuthor(*/}
            {/*                    { designation: e.target.value },*/}
            {/*                    index*/}
            {/*                  )*/}
            {/*                }*/}
            {/*              />*/}
            {/*            </Form.Item>*/}
            {/*          </Col>*/}

            {/*        </Row>*/}
            {/*      ))}*/}

            {/*    </Card>*/}
            {/*  </Col>*/}
            {/*)}*/}
            {/* 3. Co-authors Details */}
            {authorData.coAuthors && authorData.coAuthors.length > 0 && (
              <Col span={24}>
                <Card
                  title={<span><Icon type="team" /> 3. Co-authors</span>}
                  style={{ marginBottom: '24px' }}
                >
                  {authorData.coAuthors.map((item, index) => (
                    <Row gutter={8} key={index} style={{ marginBottom: 10 }}>

                      <Col span={5}>
                        <Form.Item label="Full Name*">
                          <Input
                            placeholder="Enter name"
                            value={item.name}
                            onChange={e => updateCoAuthor({ name: e.target.value }, index)}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={5}>
                        <Form.Item label="Email*">
                          <Input
                            placeholder="name@email.com"
                            value={item.email}
                            onChange={e => updateCoAuthor({ email: e.target.value }, index)}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={5}>
                        <Form.Item label="Affiliation*">
                          <Input
                            placeholder="Enter affiliation"
                            value={item.instituteAffiliated}
                            onChange={e => updateCoAuthor({ instituteAffiliated: e.target.value }, index)}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={4}>
                        <Form.Item label="Country*">
                          <Select
                            showSearch
                            placeholder="Select"
                            value={item.country}
                            onChange={val => updateCoAuthor({ country: val }, index)}
                          >
                            {Countries && Countries.map(c => (
                              <Option key={c.name} value={c.name}>{c.name}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col span={5}>
                        <Form.Item label="ORCID ID">
                          <Input
                            placeholder="0000-0000-0000-0000"
                            value={item.orcidId}
                            onChange={e => updateCoAuthor({ orcidId: e.target.value }, index)}
                          />
                        </Form.Item>
                      </Col>

                    </Row>
                  ))}
                </Card>
              </Col>
            )}
            {/* 4. Abstract & Speaker Note */}
            {/*<Col span={24}>*/}
            {/*  <Card*/}
            {/*    title={<span><Icon type="edit" /> 4. Abstract Content</span>}*/}
            {/*    style={{ marginBottom: '24px' }}*/}
            {/*  >*/}
            {/*    <Row gutter={16}>*/}
            {/*      /!* Abstract Text Area *!/*/}
            {/*      <Col span={24}>*/}
            {/*        <Form.Item label="Abstract">*/}
            {/*          {getFieldDecorator('abstract', {*/}
            {/*            initialValue: article.abstract,*/}
            {/*            rules: [{ required: true, message: 'Please enter the abstract' }],*/}
            {/*          })(*/}
            {/*            <Input.TextArea*/}
            {/*              rows={10}*/}
            {/*              placeholder="Write your abstract here..."*/}
            {/*              style={{ minHeight: '200px' }}*/}
            {/*            />*/}
            {/*          )}*/}
            {/*          <div style={{ textAlign: 'right', color: '#8c8c8c', fontSize: '12px', marginTop: '5px' }}>*/}
            {/*            {getWordCount(props.form.getFieldValue('abstract'))} / 4000 words*/}
            {/*          </div>*/}
            {/*        </Form.Item>*/}
            {/*      </Col>*/}
            <Col span={24}>
              <Card
                title={<span><Icon type="edit" /> 4. Abstract Content</span>}
                style={{ marginBottom: '24px' }}
              >
                <Row gutter={16}>
                  <Col span={24}>
                    <GetEachFormFields
                      getFieldDecorator={getFieldDecorator}
                      item={{
                        label: 'Abstract',
                        key: 'abstract',
                        type: 'ckeditor4',
                        required: true,
                        placeholder: 'Write your abstract here...',
                        rows: 10,
                        height: 300,
                        span: 24
                      }}
                      formItemLayout={formItemLayout}
                    />
                  </Col>

                  {/* Speaker Note / Short Biography */}
                  <Col span={24}>
                    <GetEachFormFields
                      getFieldDecorator={getFieldDecorator}
                      item={{
                        label: 'Short Biography / Speaker Note (Optional)',
                        key: 'speakerNote',
                        type: 'textArea',
                        placeholder: 'Enter speaker notes or short biography...',
                        rows: 4
                      }}
                      formItemLayout={formItemLayout}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
            {/* 5. Uploads Section */}
            <Col span={24}>
              <Card
                title={<span><Icon type="upload" /> 5. Uploads</span>}
                style={{ marginBottom: '24px' }}
              >
                <div style={{ marginBottom: '20px', color: '#8c8c8c', fontSize: '12px' }}>
                  Accepted formats: PDF, DOC, DOCX (Max size per file: 10 MB)
                </div>

                <Row gutter={16}>
                  {/* 1. Abstract File */}
                  <Col span={8}>
                    <Form.Item label="Abstract File attachment :">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Input
                          type="file"
                          name="abstractFile"
                          onChange={chooseDocument}
                          style={{ width: '100%' }}
                        />
                        {article.abstractFile && article.abstractFile.path && (
                          // <Button
                          //   type="link"
                          //   size="small"
                          //   icon="eye"
                          //   style={{ marginLeft: 8, color: '#722ed1', padding: 0 }}
                          //   onClick={() => window.open(article.abstractFile.path, '_blank')}
                          // />
                          <a
                            className={'linkBtn'}
                            target={'_blank'}
                            href={article.abstractFile.path}
                            style={{ marginLeft: 8, color: '#722ed1' }}
                          >
                            <Icon type={'eye'} />
                          </a>
                        )}
                      </div>
                    </Form.Item>
                  </Col>

                  {/* 2. Consent / Copyright Form */}
                  <Col span={8}>
                    <Form.Item label="Consent / Copyright Form :">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Input
                          type="file"
                          name="copyrightForm"
                          onChange={chooseDocument}
                          style={{ width: '100%' }}
                        />
                        {article.copyrightForm && article.copyrightForm.path && (
                          // <Button
                          //   type="link"
                          //   size="small"
                          //   icon="eye"
                          //   style={{ marginLeft: 8, color: '#722ed1', padding: 0 }}
                          //   onClick={() => window.open(article.copyrightForm.path, '_blank')}
                          // />
                          <a
                            className={'linkBtn'}
                            target={'_blank'}
                            href={article.copyrightForm.path}
                            style={{ marginLeft: 8, color: '#722ed1' }}
                          >
                            <Icon type={'eye'} />
                          </a>
                        )}
                      </div>
                    </Form.Item>
                  </Col>

                  {/* 3. Supporting File */}
                  <Col span={8}>
                    <Form.Item label="Supporting File attachment :">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Input
                          type="file"
                          name="supportingFile"
                          onChange={chooseDocument}
                          style={{ width: '100%' }}
                        />
                        {article.supportingFile && article.supportingFile.path && (
                          // <Button
                          //   type="link"
                          //   size="small"
                          //   icon="eye"
                          //   style={{ marginLeft: 8, color: '#722ed1', padding: 0 }}
                          //   onClick={() => window.open(article.supportingFile.path, '_blank')}
                          // />
                          <a
                            className={'linkBtn'}
                            target={'_blank'}
                            href={article.supportingFile.path}
                            style={{ marginLeft: 8, color: '#722ed1' }}
                          >
                            <Icon type={'eye'} />
                          </a>
                        )}
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
            {/* SUBMIT */}
            <Col span={24}>
              <Form.Item style={{ marginTop: 40 }}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Col>

          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

export default Form.create()(EditAbstractSubmission)
